import React from 'react';
import { useOpen } from 'AurionCR/components/hooks';
import { Button } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { useTranslate } from 'hooks/use-translate';
import { MedicalPrescriptionDialog } from 'components/medical-prescription';

interface Props {
  userPatientProfileID: string;
}
export const ButtonCreatePrescription: React.FC<React.PropsWithChildren<Props>> = ({
  userPatientProfileID,
}) => {
  const { t } = useTranslate();
  const { isOpen, handleOpen: onOpen, handleClose: onClose } = useOpen();

  return (
    <>
      <Button startIcon={<ListAltIcon />} onClick={onOpen} variant={'contained'} color={'primary'}>
        {t('create-prescription')}
      </Button>
      {isOpen && (
        <MedicalPrescriptionDialog
          userPatientProfilePrescriptionID={true}
          userPatientProfileID={userPatientProfileID}
          onClose={onClose}
          onComplete={onClose}
          onDeleted={onClose}
        />
      )}
    </>
  );
};
